/* eslint-disable */
import {
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import { useState, useEffect } from "react";
import Item from "../../utils/Item";
import PrecioVentaContadoLista from "./PrecioVentaContadoLista";

//
// ###########################################################################
//
const DatosSolucionLimpieza = ({ articulo, showPrecio = true }) => {
  const [slLcMateriales, setSlLcMateriales] = useState("");

  //
  // ################################################################################
  //
  useEffect(() => {

    const slLcMaterialList = articulo.articulo_sl_lc_material
      .map(c => c.descripcion_lc_material)
      .join(", ");

    setSlLcMateriales(slLcMaterialList);
  }, [articulo]);
  //
  // ################################################################################
  //
  return (
    <>
      {articulo && (
        <>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Solución de Limpieza
              </Typography>

              <Grid container spacing={2}>
                <Item label="Descripción" value={articulo.descripcion} />
                <Item label="Laboratorio" value={articulo.descripcion_sl_laboratorio} />
                <Item label="Presentación" value={articulo.descripcion_sl_presentacion} />
                <Item label="Marca" value={articulo.descripcion_sl_marca} />
                <Item label="Indicación" value={articulo.descripcion_sl_indicacion} />
                <Item label="Para materiales" value={slLcMateriales} />
              </Grid>
            </CardContent>
          </Card>

          {showPrecio && (
            <Card sx={{ mt: 2 }}>
              <CardContent>
                <PrecioVentaContadoLista precioVentaContado={articulo.precio_venta_contado} precioVentaLista={articulo.precio_venta_lista} />
              </CardContent>
            </Card>
          )}
        </>
      )}
    </>
  );
};
export default DatosSolucionLimpieza;
